/**
 * Offer form dropdown constants.
 * Used for lift_type, machine_type, car_construction, door_construction, door_type, flooring, margin_type.
 *
 * @author      iBirds Services
 * @copyright   www.ibirdsservices.com
 */

export const LIFT_TYPES = ["Passenger", "Goods"];
export const MACHINE_TYPES = ["geared", "gearless"];
export const CONSTRUCTION_TYPES = ["MS", "SS"];
export const DOOR_TYPES = ["auto", "manual"];
export const FLOORING_TYPES = ["PVC", "Granite"];
export const MARGIN_TYPES = ["FIXED", "PERCENTAGE"];
